import React, { useState, useEffect, useCallback } from "react";
import { FaCheckCircle, FaCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Footer from "./Footer";
import {
  Snackbar,
  Button,
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { Box, Modal } from "@mui/material";
import Bca from "../assets/bcalogo.png";
import Mandiri from "../assets/mandiri.png";
import Mastercard from "../assets/mastercardd.png";
import Visa from "../assets/visaa.png";
import Sceletol from "../assets/sceleton.png";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import apiClient from "./apiClient";
import Clock from "../assets/Clock.png";

// function Checkout() {
const PaymentPage = () => {
  const [cart, setCart] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [cartLoading, setCartLoading] = useState(true);
  const [addressLoading, setAddressLoading] = useState(true);
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [products, setProducts] = useState([]);
  const [showPopup, setShowPopup] = useState(false); // State to control the pop-up visibility
  const [productSpecs, setProductSpecs] = useState("");
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [courier, setCourier] = useState("jne");
  const [origin, setOrigin] = useState(null);
  const [shippingOptions, setShippingOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [totalWeight, setTotalWeight] = useState(0);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [editingAddress, setEditingAddress] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [snapUrl, setSnapUrl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openGateway, setOpenGateway] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [firstItemClicked, setFirstItemClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [showCards, setShowCards] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  const onClose = () => {
    setIsOpen(false); // Close modal or similar
  };

  const [isEditPopupVisible, setIsEditPopupVisible] = useState(false);
  const [addressToEdit, setAddressToEdit] = useState({
    namapenerima: "",
    nomerteleponpenerima: "",
  });

  useEffect(() => {
    const totalCartWeight = cart.reduce((acc, item) => {
      const product = item.Produk || item.produk;
      return acc + product.berat * item.jumlah; // Multiply weight by quantity
    }, 0);
    setTotalWeight(totalCartWeight); // Update total weight
  }, [cart]);

  useEffect(() => {
    const fetchOrigin = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/origin`
        );
        const data = await response.json();
        console.log("Origin API Response:", data); // Debugging response
        if (data && data[0] && data[0].kotaId) {
          setOrigin(data[0].kotaId); // Use kotaId from the response
        } else {
          console.error("No origin city ID found in the response.");
        }
      } catch (error) {
        console.error("Error fetching origin:", error);
      }
    };

    fetchOrigin();
  }, []); // This runs once when the component mounts

  const handleCourierChange = (e) => {
    setCourier(e.target.value);
  };
  console.log(setCourier);

  const handleOptionSelect = (option) => {
    setSelectedOption(option); // Store the selected option
  };

  useEffect(() => {
    const storedOption = localStorage.getItem("selectedOption");
    console.log("Stored Option:", storedOption);
    if (storedOption) {
      setSelectedOption(JSON.parse(storedOption)); // Convert back to object
    }
  }, []);

  const navigate = useNavigate();

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const fetchAddresses = async () => {
      setAddressLoading(true);
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token not found");

        const addressResponse = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/alamat`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!addressResponse.ok) {
          throw new Error(
            `Address fetch failed with status: ${addressResponse.status}`
          );
        }

        const addresses = await addressResponse.json();
        setAddresses(addresses || []);
      } catch (error) {
        console.error("Failed to fetch addresses", error);
        setAddresses([]);
      } finally {
        setAddressLoading(false);
      }
    };

    // Retrieve the full cart data from localStorage
    const storedSelectedCartItems =
      JSON.parse(localStorage.getItem("selectedCartItems")) || [];
    console.log("Stored selected cart items:", storedSelectedCartItems); // Debug log
    setCart(storedSelectedCartItems); // Set cart state with full items (not just ids)

    const fetchProductData = async () => {
      const productIds = storedSelectedCartItems.map((item) => item.produkId); // Extract produkId from cart items

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/produk/all`
        );
        if (!response.ok) {
          throw new Error(`Error fetching products: ${response.statusText}`);
        }

        const allProducts = await response.json();

        const selectedProducts = allProducts.filter((product) =>
          productIds.includes(product.id)
        );

        // Ensure all selected products have the `spesifikasi` field available
        setProducts(selectedProducts);
      } catch (error) {
        console.error("Failed to fetch products:", error);
        toast.error("Failed to fetch products. Please try again later.");
      }
    };

    fetchAddresses();
    fetchProductData();

    setCurrentStep(2);
    setCompletedSteps([true, false, false, false, false]);
  }, []);

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  const calculateTotal = (selectedCart) => {
    return selectedCart.reduce((total, item) => {
      const product = item.Produk || item.produk; // Assuming Produk is the product object

      if (product && product.harga && product.diskon !== undefined) {
        const price = parseFloat(product.harga) || 0;
        const discountPercentage = parseFloat(product.diskon) || 0;
        const quantity = parseInt(item.jumlah, 10) || 0;

        // Apply the discount if available
        const priceAfterDiscount =
          discountPercentage > 0
            ? price - (price * discountPercentage) / 100
            : price;

        // Add the price of this product (after discount) * quantity to the total
        return total + priceAfterDiscount * quantity;
      }

      return total;
    }, 0);
  };

  const totalPrice = parseFloat(localStorage.getItem("totalPrice")) || 0;

  let colorsData = {};

  const fetchColors = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/color`
      );
      const data = await response.json();
      colorsData = data.colorList.reduce((acc, color) => {
        acc[color.color_hex.toLowerCase()] = color.color_name;
        return acc;
      }, {});
    } catch (error) {
      console.error("Failed to fetch colors:", error);
    }
  };

  const hexToName = (hex) => {
    return colorsData[hex.toLowerCase()] || hex;
  };

  const rawStorage = localStorage.getItem("totalPrice");
  const totalPriceFromStorage =
    rawStorage && !isNaN(parseFloat(rawStorage))
      ? parseFloat(rawStorage)
      : null;
  console.log(totalPriceFromStorage);

  const nextStep = async () => {
    if (currentStep < 5) {
      setCompletedSteps((prevSteps) => {
        const updatedSteps = [...prevSteps];
        updatedSteps[currentStep - 1] = true;
        return updatedSteps;
      });
    }

    if (Object.keys(colorsData).length === 0) {
      await fetchColors();
    }

    const selectedPaymentType = localStorage.getItem("paymentType") || "";
    const selectedAddress = JSON.parse(localStorage.getItem("selectedAddress"));

    // Parse totalPriceFromStorage safely
    const rawStorage = localStorage.getItem("totalPrice");
    const totalPriceFromStorage =
      rawStorage && !isNaN(parseFloat(rawStorage))
        ? parseFloat(rawStorage)
        : null;

    const diskon = parseFloat(localStorage.getItem("diskonPersen")) || 0;
    const kodepromo = parseFloat(localStorage.getItem("diskonId")) || 0;

    // Step 1: Calculate item subtotals with priceAfterDiscount

    const itemSubtotals = cart.map((item) => {
      const produk = item.produk || item.Produk || {};
      const basePrice = parseFloat(produk.harga) || 0;
      const discountPercentage = parseFloat(produk.diskon) || 0;

      const priceAfterDiscount =
        discountPercentage > 0
          ? basePrice - (basePrice * discountPercentage) / 100
          : basePrice;

      const jumlah = parseFloat(item.jumlah);
      const subtotal = priceAfterDiscount * jumlah;

      return {
        item,
        priceAfterDiscount,
        jumlah,
        subtotal,
      };
    });

    const cartTotal = itemSubtotals.reduce((sum, i) => sum + i.subtotal, 0);
    console.log("carttotal:", cartTotal);

    const rawTotal = itemSubtotals.reduce((sum, i) => sum + i.subtotal, 0);
    const adjustedTotal = totalPriceFromStorage ?? rawTotal;
    console.log("adjustotal:", adjustedTotal);
    const produkData = itemSubtotals.map(({ item, subtotal }, idx) => {
      let harga_per_item;
      const totalJumlah = itemSubtotals.reduce((sum, x) => sum + x.jumlah, 0);

      if (totalPriceFromStorage) {
        // Allocate promo total proportionally
        const prop = subtotal / rawTotal;
        const totalItemPrice = adjustedTotal * prop;
        harga_per_item = totalItemPrice / item.jumlah;
      } else {
        harga_per_item = subtotal / item.jumlah;
      }

      return {
        produkId: item.produkId,
        jumlah: item.jumlah,
        color: item.color_hex,
        harga_per_item: Math.round(harga_per_item), // round for consistency
      };
    });

    const pendingRegisterData = JSON.parse(
      localStorage.getItem("pendingRegisterData") || "{}"
    );

    const payload = {
      diskon,
      kodepromo,
      produkData,
      totalPrice: adjustedTotal,
      address: selectedAddress?.id,
      lokasi: pendingRegisterData.lokasi,
      lama_kirim: selectedOption.etd,
      nama_ekspedisi: selectedOption.service_name,
      kode_ekspedisi: selectedOption.shipping_name,
      shippingCost: selectedOption.shipping_cost || 0,
      paymentType: selectedPaymentType,
      midtransOptions: {
        credit_card: {
          secure: true,
        },
      },
    };

    console.log("Final Payload:", payload);

    try {
      // Step 1: Create order
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/order/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to create order");
      }
      const data = await response.json();
      console.log("Order Response:", data);
      const { snapUrl, orderId } = data;
      if (!snapUrl || !orderId) {
        throw new Error("Missing snapUrl or orderId in the response");
      }
      // Save orderId to localStorage
      localStorage.setItem("orderId", orderId);
      localStorage.setItem("snapUrl", snapUrl);
      setSnapUrl(snapUrl);
      // Step 2: Send reminder-va
      const userId = localStorage.getItem("userId");
      const userRes = await apiClient.get(`/user/${userId}?lokasi=sby`);
      const orderid = localStorage.getItem("orderId");
      const orderRes = await apiClient.get(`/order/items/${orderId}`);
      console.log(userRes);
      const email = userRes?.data?.user?.email;
      const namaProduk = orderRes?.produk?.nama_produk;
      const imageProduk = orderRes?.image;
      const produkList = orderRes.data; // the array you just showed
      const products = produkList.map((item) => ({
        nama_produk: item.nama_produk,
        image: item.image, // already contains full URL: https://musique.co.id/...
      }));
      console.log(email);
      if (!email) {
        console.error("Email is undefined. Cannot send reminder.");
        throw new Error("Email not found for user.");
      }
      await apiClient.post("/order/reminder-va", {
        email,
        snapUrl,
        orderid,
        products,
        userId,
      });
      // Step 3: Delete cart items
      const cartDeletePromises = cart.map((item) =>
        fetch(`${process.env.REACT_APP_API_BASE_URL}/cart/${item.id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
      );
      await Promise.all(cartDeletePromises);
      // Step 4: Clear localStorage
      localStorage.removeItem("selectedCartItems");
      localStorage.removeItem("selectedItems");
      localStorage.removeItem("selectedAddressId");
      localStorage.removeItem("cart");
      localStorage.removeItem("totalPrice");
      localStorage.removeItem("diskonId");
      localStorage.removeItem("diskonPersen");
      // Step 5: Feedback to user
      toast.success("Order created successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      toast.success("Payment gateway opened successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setOpenModal(true);
      setCurrentStep(currentStep + 1);
      // Step 6: Redirect to custom snap-url page (or use redirect directly to Midtrans)
      window.location.href = "/snap-url";
      // or use: window.location.href = snapUrl;
    } catch (error) {
      console.error("Error in nextStep:", error);
      toast.error(`An error occurred: ${error.message || "Unknown error"}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const prevStep = () => {
    if (currentStep === 2) {
      navigate("/cart");
    } else if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  // Show pop-up with product specification when clicked
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [hoveredProductId, setHoveredProductId] = useState(null); // State untuk melacak produk yang di-hover

  // Perbaiki fungsi handleProductSpecificationClick
  const handleProductSpecificationClick = (product) => {
    setSelectedProductId(product.id); // Simpan ID produk yang diklik
    setShowPopup(true); // Tampilkan pop-up
  };

  const [formData, setFormData] = useState({
    namapenerima: "",
    alamat: "",
    kotaataukelurahan: "",
    provinsi: "",
    kodePos: "",
    main: "Rumah",
    nomeralamat: "",
    nomerteleponpenerima: "",
    status: "Utama",
    provinsiId: "",
    kotaId: "",
  });

  // Fetch provinces
  // useEffect(() => {
  //   const fetchProvinces = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_BASE_URL}/rajaongkir/provinces`
  //       );
  //       if (response.ok) {
  //         const data = await response.json();
  //         setProvinces(data.rajaongkir.results);
  //       } else {
  //         console.error("Failed to fetch provinces");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching provinces:", error);
  //     }
  //   };

  //   fetchProvinces();
  // }, []);

  // Fetch cities when province changes
  const fetchCities = async (provinceId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/rajaongkir/cities?province=${provinceId}`
      );
      if (response.ok) {
        const data = await response.json();
        setCities(data.rajaongkir.results);
      } else {
        console.error("Failed to fetch cities");
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCities([]);
    }
  };

  // Handle form input changes

  fetchColors();

  console.log(snapUrl);

  const orderid = localStorage.getItem("orderId");
  console.log(orderid);

  useEffect(() => {
    console.log("snapUrl updated:", snapUrl);
  }, [snapUrl]);

  // Update VA URL when snapUrl changes
  useEffect(() => {
    const updateVaUrl = async () => {
      const orderId = localStorage.getItem("orderId");
      const token = localStorage.getItem("token");
      if (orderId && snapUrl) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_BASE_URL}/order/vaurl/${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ vaurl: snapUrl }),
            }
          );

          if (!response.ok) {
            const errorData = await response.json();
            console.error("Failed to update VA URL:", errorData);
            toast.error("Failed to update VA URL");
          } else {
            console.log("VA URL updated successfully.");
          }
        } catch (error) {
          console.error("Error updating VA URL:", error);
          toast.error("Error updating VA URL");
        }
      }
    };

    if (snapUrl) updateVaUrl();
  }, [snapUrl]);

  useEffect(() => {
    const storedSnapUrl = localStorage.getItem("snapUrl");
    console.log(snapUrl);
    if (storedSnapUrl) {
      setSnapUrl(storedSnapUrl);
      setOpenGateway(true);
      toast.success("Payment gateway opened successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      localStorage.removeItem("snapUrl");
    }
  }, []);

  const handleCloseGateway = () => {
    setOpenGateway(false);
    setSnapUrl(null);
  };

  const nextShipping = () => {
    window.location.href = "/shipping-page";
  };

  const accordionItems = [
    {
      id: 1,
      ask: "Transfer Bank",
      title: "",
      content: "Bank BCA",
      image: Bca,
      norek: 7090366712,
      an: "V2 INDONESIA",
      conten: "Bank Mandiri",
      nore: 12200049991157,
      img: Mandiri,
    },
    {
      id: 2,
      ask: "Virtual Account",
    },
    {
      id: 3,
      ask: "Debit/Credit Card",
      gambar: Mastercard,
      gmbr: Visa,
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const handleSectionClick = (bank) => {
    setShowCards(true);
    setSelectedBank(bank);
  };

  const handleBackToAccordion = (index) => {
    toggleAccordion(index);
    setShowCards(false);
  };

  const [accountNumber, setAccountNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [nama, setNama] = useState("");
  const [bank, setBank] = useState("");
  const [norek, setNorek] = useState("");
  const [jumlah, setJumlah] = useState("");

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];

    if (
      file &&
      !["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    ) {
      alert("Invalid file type. Only JPG, PNG, or PDF allowed.");
      return;
    }

    setSelectedFile(file);
  }, []);
  // Drag & Drop Logic
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*,application/pdf",
    onDrop: (acceptedFiles) => {
      setSelectedFile(acceptedFiles[0]);
    },
    multiple: false,
    maxSize: 10 * 1024 * 1024, // Optional: 10MB max
  });

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      alert("Please upload a file.");
      return;
    }

    const selectedPaymentType = localStorage.getItem("paymentType") || "";

    const TotalWeight = localStorage.getItem("totalWeight");
    const selectedAddress = JSON.parse(localStorage.getItem("selectedAddress"));

    const totalPriceFromStorage =
      parseFloat(localStorage.getItem("totalPrice")) || null;
    const diskonPersen = parseFloat(localStorage.getItem("diskonPersen")) || 0;
    const diskonNilai = parseFloat(localStorage.getItem("diskonNilai")) || 0;

    // const diskon = parseFloat(localStorage.getItem("diskonPersen")) || 0;
    const diskon = diskonPersen || diskonNilai;

    const kodepromo = parseFloat(localStorage.getItem("diskonId")) || 0;

    const itemSubtotals = cart.map((item) => {
      const produk = item.produk || item.Produk || {};
      const hargaArray = produk.harga || [];
      const basePrice = Number(hargaArray[0]) || 0;
      const discountPercentage = Number(produk.diskon) || 0;

      const priceAfterDiscount =
        discountPercentage > 0
          ? basePrice - (basePrice * discountPercentage) / 100
          : basePrice;

      const jumlah = Number(item.jumlah);
      const subtotal = priceAfterDiscount * jumlah;

      return {
        item,
        basePrice: priceAfterDiscount,
        jumlah,
        subtotal,
      };
    });

    // Calculate total cart price before promo
    const cartTotal = itemSubtotals.reduce((sum, i) => sum + i.subtotal, 0);

    const rawTotal = calculateTotal(cart); // original cart total
    console.log(rawTotal);

    // Create produkData with proportional or original pricing
    const produkData = itemSubtotals.map(
      ({ item, basePrice, jumlah, subtotal }) => {
        let hargaPerItem = basePrice;

        // Distribute promo price proportionally if available
        if (rawTotal && cartTotal > 0) {
          const ratio = subtotal / cartTotal;
          const adjustedSubtotal = rawTotal * ratio;
          hargaPerItem = adjustedSubtotal / jumlah;
        }

        return {
          produkId: item.produkId,
          jumlah,
          color: item.color_hex,
          harga_per_item: Math.round(hargaPerItem), // round if you want whole numbers
        };
      }
    );

    const pendingRegisterData = JSON.parse(
      localStorage.getItem("pendingRegisterData") || "{}"
    );

    const payload = {
      diskon: diskon,
      kodepromo: kodepromo,
      produkData: produkData,
      address: selectedAddress?.id,
      lokasi: pendingRegisterData.lokasi,
      lama_kirim: selectedOption.etd,
      nama_ekspedisi: selectedOption.service_name,
      kode_ekspedisi: selectedOption.shipping_name,
      shippingCost: selectedOption.shipping_cost || 0,
      paymentType: selectedPaymentType,
      totalWeight: TotalWeight,
    };

    console.log(payload);
    try {
      // Step 1: Create order
      const orderResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/order/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!orderResponse.ok) {
        const errorData = await orderResponse.json();
        console.error("Order creation failed:", errorData);
        throw new Error(errorData.message || "Failed to create order");
      }

      const orderData = await orderResponse.json();
      const orderId = orderData.orderId;
      if (!orderId) throw new Error("Order ID is missing in the response");

      localStorage.setItem("orderId", orderId);

      // Step 2: Upload payment proof
      const formData = new FormData();
      formData.append("nama", nama);
      formData.append("bank", bank);
      formData.append("norek", norek);
      formData.append("jumlah", jumlah);
      formData.append("noorder", orderId);
      formData.append("image", selectedFile);
      formData.append("lokasi", pendingRegisterData.lokasi);

      const uploadResponse = await fetch(
        "https://musiquestore.cloud/musiquebackend/buktibayar",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: formData,
        }
      );

      const uploadResult = await uploadResponse.json();
      if (!uploadResponse.ok) {
        if (uploadResult.message?.toLowerCase().includes("duplicate")) {
          alert("This payment proof has already been uploaded.");
        } else {
          alert("Upload failed: " + uploadResult.message);
        }
        return;
      }

      // Step 3: Clear cart
      const deleteRequests = cart.map((item) =>
        fetch(`${process.env.REACT_APP_API_BASE_URL}/cart/${item.id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
      );
      await Promise.all(deleteRequests);

      // Step 4: Clear localStorage
      localStorage.removeItem("selectedCartItems");
      localStorage.removeItem("selectedItems");
      // localStorage.removeItem("selectedAddressId");
      localStorage.removeItem("cart");
      // localStorage.removeItem("selectedOption");

      // Step 5: Navigate to thank you page
      toast.success("Order created & payment uploaded successfully!", {
        autoClose: 3000,
      });
      navigate("/thankyou-page");
    } catch (error) {
      console.error("Submit error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  // Calculate total item count and total due
  const totalItems = cart.reduce((sum, item) => sum + item.jumlah, 0);

  const totalDue =
    cart.reduce((sum, item) => {
      const produk = item.produk || item.Produk || {};
      const hargaArray = produk.harga || [];
      const basePrice = Number(hargaArray[0]) || 0;
      const discount = Number(produk.diskon) || 0;
      const quantity = Number(item.jumlah) || 0;

      const priceAfterDiscount =
        discount > 0 ? basePrice - (basePrice * discount) / 100 : basePrice;

      const itemTotal = priceAfterDiscount * quantity;

      return sum + itemTotal;
    }, 0) + (selectedOption?.shipping_cost || 0);

  return (
    <>
      <div className="mt-28 mb-28 px-10 md:px-40 bg-gray-100 p-8">
        {/* <ToastContainer /> */}
        <div className="flex md:justify-between items-center overflow-x-auto md:overflow-visible no-scrollbar gap-6 md:gap-0 mb-6 md:mb-8 lg:mb-10 px-2">
          {["Cart", "Shipping", "Delivery", "Payment", "Summary"].map(
            (step, index) => (
              <div
                key={index}
                className="relative flex items-center text-sm md:text-base lg:text-lg font-medium text-gray-800 flex-shrink-0"
              >
                {/* Step Circle */}
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full text-white font-bold 
          ${index < 3 ? "bg-black" : "bg-gray-300"}`}
                >
                  {index < 3 ? "✔" : index + 1}
                </div>

                {/* Step Name */}
                <p className="ml-3 whitespace-nowrap">{step}</p>

                {/* Connector Line */}
                {index < 4 && (
                  <div className="hidden sm:block absolute left-full ml-3 top-1/2 transform -translate-y-1/2 w-12 md:w-16 lg:w-20 border-b-4 border-gray-700"></div>
                )}
              </div>
            )
          )}
        </div>

        <h2 className="text-3xl font-bold mb-6">Payment</h2>

        <div>
          {!showCards ? (
            <div className="accordion-group bg-white p-5 mb-14 shadow-lg rounded-lg">
              <div>
                {accordionItems.map((item, index) => (
                  <div
                    key={item.id}
                    className={`accordion py-8 border-b border-solid border-gray-200 ${activeIndex === index ? "active" : ""
                      }`}
                  >
                    <button
                      className="accordion-toggle group inline-flex items-center justify-between text-xl font-normal leading-8 text-gray-600 w-full transition duration-500 hover:text-indigo-600 bg-transparent border-b border-transparent p-0 hover:bg-transparent"
                      onClick={() => {
                        if (isDisabled) return; // ✅ prevent click if disabled
                        console.log(`Clicked on: ${item.ask}`);
                        toggleAccordion(index);
                      }}
                      aria-controls={`accordion-content-${item.id}`}
                      aria-expanded={activeIndex === index}
                      disabled={isDisabled} // ✅ disable button visually
                    >
                      <div className="flex items-center gap-4">
                        <h5
                          className={`pb-2.5 ${isDisabled
                              ? "pointer-events-none text-gray-400"
                              : ""
                            }`} // ✅ optional visual cue
                          onClick={() => {
                            if (isDisabled) return; // ✅ prevent action if disabled

                            if (item.ask.trim() === "Virtual Account") {
                              console.log(
                                "Running nextStep() for Virtual Account"
                              );
                              localStorage.setItem(
                                "paymentType",
                                "bank_transfer"
                              );
                              setIsDisabled(true); // ✅ disable all further interactions
                              nextStep();
                            } else if (
                              item.ask.trim() === "Debit/Credit Card"
                            ) {
                              console.log(
                                "Running nextStep() for Debit Card/CC"
                              );
                              localStorage.setItem(
                                "paymentType",
                                "credit_card"
                              );
                              setIsDisabled(true); // ✅ disable all further interactions
                              nextStep();
                            }
                          }}
                        >
                          {item.ask}
                        </h5>

                        {item.gambar && (
                          <img
                            src={item.gambar}
                            className="w-16 h-12"
                            alt={`Gambar ${item.id}`}
                          />
                        )}
                        {item.gmbr && (
                          <img
                            src={item.gmbr}
                            className="w-16 h-6"
                            alt={`Gmbr ${item.id}`}
                          />
                        )}
                      </div>
                      {/* <svg
                        className={`text-gray-900 transition duration-500 group-hover:text-indigo-600 ${
                          activeIndex === index ? "rotate-180" : ""
                        }`}
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 8.25L12.4142 12.3358C11.7475 13.0025 11.4142 13.3358 11 13.3358C10.5858 13.3358 10.2525 13.0025 9.58579 12.3358L5.5 8.25"
                          stroke="currentColor"
                          strokeWidth="1.6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg> */}
                    </button>

                    <div
                      id={`accordion-content-${item.id}`}
                      className={`accordion-content w-full px-0 overflow-hidden pr-4 transition-max-height duration-500 ease-in-out ${activeIndex === index ? "max-h-screen" : "max-h-0"
                        }`}
                      style={{
                        maxHeight: activeIndex === index ? "300px" : "0",
                      }}
                    >
                      <h2 className="font-normal text-xl mb-4">{item.title}</h2>

                      {(item.image || item.content) && (
                        <div
                          className="flex items-center gap-4 cursor-pointer"
                          onClick={() => handleSectionClick("Bca")}
                        >
                          {item.image && (
                            <img
                              src={item.image}
                              className="w-16 h-12"
                              alt={`Bank ${item.id}`}
                            />
                          )}
                          {item.content && (
                            <p className="text-base font-normal text-gray-600">
                              {item.content}
                            </p>
                          )}
                        </div>
                      )}

                      {(item.img || item.conten) && (
                        <div
                          className="flex items-center gap-4 mt-2 cursor-pointer"
                          onClick={() => handleSectionClick("Mandiri")}
                        >
                          {item.img && (
                            <img
                              src={item.img}
                              className="w-16 h-8"
                              alt={`Bank ${item.id}`}
                            />
                          )}
                          {item.conten && (
                            <p className="text-base font-normal text-gray-600">
                              {item.conten}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <>
              <div className="flex flex-col lg:flex-row gap-6 p-5 rounded-lg">
                {/* Account Number Card */}
                <div className="relative w-full lg:w-2/3 grid grid-cols-1 md:grid-cols-1 px:4 md:px-10">
                  {/* Top-right button */}
                  <div className="block md:absolute md:right-8 md:z-10 text-center py-2 justify-end px-0 mr-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent parent onClick
                        handleBackToAccordion(0);
                      }}
                      className="w-[127px] md:w-[200px] h-14 text-sm md:text-lg text-white bg-gray-900 transition-all duration-300 ease-in-out 
                        hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Choose Another Bank
                    </button>
                  </div>
                  <div className="relative hover:shadow-xl w-full grid grid-cols-2 px-4 md:px-10 py-6 border border-gray-300 rounded-lg shadow-lg bg-white my-auto md:mt-24">
                    {/* Account Info */}
                    <div className="justify-center space-y-4 my-auto">
                      <div>
                        <h3 className="text-sm md:text-base">Account Number</h3>
                        <p className=" font-semibold">
                          {selectedBank === "Mandiri"
                            ? "12200049991157"
                            : "7090366712"}
                        </p>
                      </div>
                      <div>
                        <h3 className="text-sm md:text-base">Account Name</h3>
                        <p className=" font-semibold">V2 INDONESIA</p>
                      </div>
                      <div>
                        <h3 className="text-sm md:text-base">Amount to Pay</h3>
                        {cart.length === 0 ? (
                          <p className="text-sm text-gray-500 text-center">
                            No items in your cart.
                          </p>
                        ) : (
                          <div className="space-y-1">
                            <p>
                              <span className="text-lg font-bold text-black">
                                {/* {formatRupiah(totalDue)} */}
                                {formatRupiah(
                                  totalPrice +
                                  (selectedOption
                                    ? selectedOption.shipping_cost
                                    : 0)
                                )}
                              </span>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Bank Logo */}
                    <div className="px-2 flex items-center justify-center">
                      <img
                        src={selectedBank === "Bca" ? Bca : Mandiri}
                        className="w-64 h-18"
                        alt={selectedBank}
                      />
                    </div>
                  </div>
                </div>

                {/* Order Summary Card */}
                <div className="hover:shadow-xl w-full lg:w-1/3 p-4 border border-gray-300 rounded-lg shadow-lg bg-white">
                  <h3 className="text-lg font-semibold mb-4 text-center md:text-left">
                    Order Summary
                  </h3>

                  <div className="space-y-6">
                    {cart.length === 0 ? (
                      <p className="text-sm text-gray-500 text-center">
                        No items in your cart.
                      </p>
                    ) : (
                      cart.map((item, index) => {
                        const product = item.Produk || item.produk || {};
                        const hargaArray = product.harga || [];
                        const basePrice = Number(hargaArray[0]) || 0;
                        const discount = Number(product.diskon) || 0;
                        const quantity = Number(item.jumlah) || 0;
                        const color = item.colorName;
                        const totalPrice =
                          parseFloat(localStorage.getItem("totalPrice")) || 0;

                        const priceAfterDiscount =
                          discount > 0
                            ? basePrice - (basePrice * discount) / 100
                            : basePrice;
                        // ?  totalPrice - (totalPrice * discount) / 100
                        // : totalPrice;

                        const subtotal = priceAfterDiscount * quantity;
                        const originalSubtotal = basePrice * quantity;
                        // const originalSubtotal = totalPrice * quantity;

                        return (
                          <div
                            key={`${product.id}-${index}`}
                            className="bg-white rounded-lg p-4"
                          >
                            <div className="flex flex-col md:flex-row gap-4">
                              <div className="flex-1 space-y-1">
                                <h2 className="text-base md:text-lg font-semibold">
                                  {product.brand?.nama_brand}{" "}
                                  {product.nama_produk}
                                </h2>
                                {item?.preorder === "Y" && (
                                  <div className="relative w-full text-start">
                                    <div className="bg-white text-[#CCAB5C] py-1 font-semibold text-base md:text-lg flex items-center gap-2">
                                      <img
                                        src={Clock}
                                        alt="Clock icon"
                                        className="h-6 w-6"
                                      />{" "}
                                      Pre-Order
                                    </div>
                                  </div>
                                )}
                                <p className="text-sm text-gray-700">
                                  Quantity:{" "}
                                  <span className="font-medium">
                                    {quantity}
                                  </span>
                                </p>
                                <p className="text-sm text-gray-700">
                                  Weight: {(product.berat / 1000) * quantity} Kg
                                </p>
                                <p className="text-sm text-gray-700">
                                  Color: {color}
                                </p>
                              </div>

                              <div className="flex-1 space-y-2 border-t md:border-t-0 md:border-l border-gray-200 pt-4 md:pt-0 md:pl-4">
                                <div className="text-sm flex flex-col">
                                  <span className="font-semibold">
                                    {formatRupiah(subtotal)}
                                  </span>
                                  {discount > 0 && (
                                    <span className="text-xs text-red-500 line-through ml-2">
                                      {formatRupiah(originalSubtotal)}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>

                  {/* Totals Section */}
                  {cart.length > 0 && (
                    <div className="ml-4 flex flex-col text-sm md:flex-row gap-4 pt-4 border-t mt-6">
                      <span className="flex-1 space-y-1 text-gray-600">
                        Subtotal:
                      </span>
                      <span className="flex-1 space-y-2 font-bold text-black">
                        {formatRupiah(
                          cart.reduce((acc, item) => {
                            const product = item.Produk || item.produk || {};
                            const hargaArray = product.harga || [];
                            const basePrice = Number(hargaArray[0]) || 0;
                            const totalPrice =
                              parseFloat(localStorage.getItem("totalPrice")) ||
                              0;
                            const discount = Number(product.diskon) || 0;
                            const quantity = Number(item.jumlah) || 0;
                            const priceAfterDiscount =
                              discount > 0
                                ? basePrice - (basePrice * discount) / 100
                                : basePrice;
                            // ? totalPrice - (totalPrice * discount) / 100
                            // : totalPrice;

                            return acc + priceAfterDiscount * quantity;
                          }, 0)
                        )}
                      </span>
                    </div>
                  )}

                  <div className="ml-4 flex flex-col md:flex-row text-sm gap-4 pt-4 border-t mt-6">
                    <span className="text-gray-600 min-w-[80px] flex-1 space-y-1">
                      Discount:
                    </span>
                    <span className="font-semibold flex-1 space-y-2">
                      {formatRupiah(
                        parseFloat(localStorage.getItem("potongan")) || 0
                      )}
                    </span>
                  </div>

                  <div className="ml-4 flex flex-col md:flex-row text-sm gap-4 pt-4 border-t mt-6">
                    <span className="text-gray-600 min-w-[80px] flex-1 space-y-1">
                      Delivery:
                    </span>
                    <span className="font-semibold flex-1 space-y-2">
                      {formatRupiah(
                        selectedOption ? selectedOption.shipping_cost : 0
                      )}
                    </span>
                  </div>

                  <div className="ml-4 flex flex-col md:flex-row text-sm gap-4 pt-4 border-t mt-6">
                    <span className="text-gray-600 flex-1 space-y-1">
                      Total Due:
                    </span>
                    <span className="font-bold text-black flex-1 space-y-2">
                      {formatRupiah(
                        totalPrice +
                        (selectedOption ? selectedOption.shipping_cost : 0)
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* <div className="max-w-lg bg-white p-6 rounded-lg shadow-lg mt-10"> */}
              <div className="flex flex-col lg:flex-row gap-6 p-5 rounded-lg">
                {/* Form Card */}
                <div className="px-8 w-full lg:w-2/3 p-4 border border-gray-300 rounded-lg shadow-lg bg-white">
                  <h3 className="text-xl font-bold text-gray-800 text-center mb-6">
                    You need to enter your account information and payment proof
                    for payment verification by the admin.
                  </h3>

                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Account Name
                      </label>
                      <input
                        type="text"
                        value={nama}
                        onChange={(e) => setNama(e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter Account Name"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Bank Name
                      </label>
                      <input
                        type="text"
                        value={bank}
                        onChange={(e) => setBank(e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter Bank Name"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Account Number
                      </label>
                      <input
                        type="text"
                        value={norek}
                        pattern="\d{6,20}"
                        title="Account number must be 6-20 digits"
                        onChange={(e) => setNorek(e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter Account Number"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-medium mb-1">
                        Total Transfer
                      </label>
                      <input
                        type="number"
                        value={jumlah}
                        min="1"
                        max="1000000000"
                        onChange={(e) => setJumlah(e.target.value)}
                        onWheel={(e) => e.target.blur()}
                        className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 no-spinner"
                        placeholder="Enter Amount"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-medium mb-2">
                        Upload File
                      </label>
                      <div
                        {...getRootProps()}
                        className="border-2 border-dashed border-gray-400 p-6 rounded-lg cursor-pointer hover:border-blue-500 flex flex-col items-center justify-center text-center"
                      >
                        <input
                          {...getInputProps({
                            accept: "image/jpeg, image/png, application/pdf",
                            maxSize: 10 * 1024 * 1024, // 10MB
                          })}
                        />

                        {selectedFile ? (
                          <p className="text-gray-700">{selectedFile.name}</p>
                        ) : (
                          <>
                            <img
                              src={Sceletol}
                              className="w-20 h-20 object-contain mb-3 p-4"
                              alt="Upload Icon"
                            />
                            <p className="text-gray-700 font-medium">
                              Drag & Drop file here, or click to select
                            </p>
                            <p className="text-gray-500 text-sm mt-1">
                              Attach bank receipt or transaction screenshot. Max
                              file size 10MB.
                            </p>
                          </>
                        )}
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-500 transition-all duration-300 font-semibold"
                    >
                      I HAVE PAID
                    </button>
                  </form>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaymentPage;
